<template>
  <div class="text-dark">
    <h3 class="title">Mes Matières</h3>
    <div v-if="subjects.length" class="row">
      <div v-for="(subject,i) in subjects" :key="i" class="col-12 col-md-6 col-xl-4 mb-3">
        <subject-view :subject="subject"></subject-view>
      </div>
    </div>
    <div v-else>
      <p>
        Aucune matiere presente actuellement
      </p>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import SubjectView from "./SubjectView";

export default {
  name: "SubjectList",
  components: {SubjectView},
  computed: {
    ...mapGetters({
      'subjects': 'subject/subjects',
    })
  },
  data() {
    return {}
  },
  created() {
  }
}
</script>

<style>
</style>
